mutation registerSeminarUsers(
  $assignmentId: String!
  $eventId: String!
  $primaryUsergroup: String!
  $users: [LMSSeminarUser]
) {
  registerSeminarUsers(
    assignmentId: $assignmentId
    eventId: $eventId
    primaryUsergroup: $primaryUsergroup
    users: $users
  )
}
